import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Page = styled.div`
  min-height: 100vh;
  padding: 24px;
  background: ${({ theme }) => theme.COLORS.WIDGETCOLOR};
  ${FLEX.FlexCenterCenter};
`;

export const Card = styled.div`
  width: 100%;
  max-width: 456px;
  padding: 30px;
  border-radius: 16px;
  background: ${({ theme }) => theme.COLORS.FILTERITEM};
  border: 1px solid ${({ theme }) => `${theme.COLORS.WHITE}08`};
  color: ${({ theme }) => theme.COLORS.WHITE};
  text-align: center;
  ${FLEX.FlexStartCenter};
  flex-direction: column;

  ${mediaQuery.isMobile} {
    padding: 20px;
  }
  .button {
    width: 100%;
    height: 44px;
  }
`;

export const StatusBadge = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: ${({ theme }) => `${theme.COLORS.BUTTONS2}22`};
  color: ${({ theme }) => theme.COLORS.BUTTONS2};
  margin-bottom: 18px;
`;

export const ErrorBadge = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: ${({ theme }) => `${theme.COLORS.VALIDATERED}22`};
  color: ${({ theme }) => theme.COLORS.VALIDATERED};
  margin-bottom: 18px;
`;

export const LoadingBar = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: ${({ theme }) => `${theme.COLORS.WHITE}14`};
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    height: 100%;
    width: 40%;
    border-radius: 999px;
    background: ${({ theme }) => theme.COLORS.BUTTONS2};
    animation: slide 1.1s ease-in-out infinite;
  }

  @keyframes slide {
    0% {
      transform: translateX(-120%);
    }
    50% {
      transform: translateX(120%);
    }
    100% {
      transform: translateX(280%);
    }
  }
`;

export const Title = styled.h1`
  margin-bottom: 16px;
  font-size: ${calcRem(24)};
  font-weight: 500;
  line-height: 1.2;
`;

export const Description = styled.p`
  margin-bottom: 22px;
  line-height: 1.45;
  color: ${({ theme }) => theme.COLORS.BUTTONS3};
`;

export const NextCard = styled.div`
  width: 100%;
  margin-bottom: 22px;
  padding: 18px;
  border-radius: 8px;
  background: ${({ theme }) => `${theme.COLORS.WIDGETCOLOR}32`};
  border: 1px solid ${({ theme }) => `${theme.COLORS.WHITE}10`};
  text-align: left;

  h2 {
    font-size: ${calcRem(16)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
    padding-bottom: 10px;
  }

  ul {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 10px;
  }

  li {
    position: relative;
    padding-left: 14px;
    font-size: ${calcRem(14)};
    line-height: 1.4;
    color: ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.BUTTONS3
        : `${theme.COLORS.BUTTONS1}`};

    &::before {
      content: "";
      position: absolute;
      top: 8px;
      left: 0;
      width: 6px;
      height: 6px;
      border-radius: 999px;
      background: ${({ theme }) =>
        theme.value === "light"
          ? theme.COLORS.BUTTONS3
          : `${theme.COLORS.BUTTONS1}`};
    }
  }
`;

export const SummaryHeader = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  margin-bottom: 14px;

  svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.COLORS.BUTTONS2};
  }
`;

export const SummaryRow = styled.div`
  ${FLEX.FlexBetweenCenter};
  gap: 12px;
  font-size: ${calcRem(14)};
  line-height: 1.4;
  padding: 6px 0;

  span {
    &:first-child {
      color: ${({ theme }) => theme.COLORS.WHITE};
    }

    &:last-child {
      color: ${({ theme }) =>
        theme.value === "light"
          ? theme.COLORS.BUTTONS3
          : `${theme.COLORS.BUTTONS1}`};
      text-align: right;
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 18px 0;
  background: ${({ theme }) => `${theme.COLORS.WHITE}14`};
`;

export const SummaryMeta = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 14px;
`;

export const MetaRow = styled.div`
  width: 100%;
  ${FLEX.FlexBetweenCenter};
  gap: 12px;
  font-size: ${calcRem(14)};
  line-height: 1.4;

  .label {
    ${FLEX.FlexStartCenter};
    gap: 8px;
    color: ${({ theme }) => theme.COLORS.BUTTONS3};

    svg {
      width: 16px;
      height: 16px;
      color: ${({ theme }) => theme.COLORS.BUTTONS3};
    }
  }

  .value {
    color: ${({ theme }) => theme.COLORS.WHITE};
    text-align: right;
    white-space: nowrap;
  }

  .value.strong {
    font-size: ${calcRem(16)};
    font-weight: 500;
  }
`;
